import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { ConvertService } from 'src/app/services/convert.service';
import { GENDERS, DISPLAY_STATUS_OBJECT, PACKAGE_ARR, APP_MEMBER_OBJECT } from 'src/app/dummy/status';
import { TrainingStore } from 'src/app/stores/training/training.store';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { ISchool } from 'src/app/interfaces/student';

@Component({
  selector: 'app-school-form',
  templateUrl: './school-form.component.html',
  styleUrls: ['./school-form.component.scss']
})
export class SchoolFormComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
   @ViewChild('photoFile',{static:false}) photoFile: ElementRef;

  form: FormGroup;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  TITLE = 'Add New';
  GENDER: any = GENDERS;
  ITEM: ISchool;
  PACKAGES = PACKAGE_ARR;

  START_UPLOAD: boolean;
  uploadPercent: any;
  SELECTED_PICTURE_FILE: any;
  imageSrc: string;

  constructor(
    public dialogRef: MatDialogRef<SchoolFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: TrainingStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private storage: FireStorageService,
  ) { }

  ngOnInit() {
    const { STUDENT } = this.data;
    this.TITLE = `Add New School`
    this.ITEM = STUDENT || null;
    this.form = this.fb.group({
      firstName: [STUDENT ? STUDENT.name : null, Validators.compose([Validators.required])],
      lastName: [STUDENT ? STUDENT.khmerName : null, Validators.compose([Validators.required])],
      phoneNumber: [STUDENT ? STUDENT.phoneNumber : null],
      email: [STUDENT ? STUDENT.email : null],
    })
    if (STUDENT) {
      this.TITLE = `Edit School`
    }
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  async uploadFilePicture(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_PICTURE_FILE = event.target.files[0];
      this.photoFile.nativeElement.value = "";
      if (this.ITEM) {
        //PICTURE
        this.START_UPLOAD = true;
        const file = this.SELECTED_PICTURE_FILE;
        const fileName = file.name;
        const uploadPath = `students/${this.ITEM.key}/${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        this.ITEM.photoFileDetail = files;
        this.store.saveSchool(this.ITEM, (success, res) => {
          if (success) {
            this.snackBar.open("Member has been saved successful.", "Done", { duration: 2500 });
          }
          this.processNew = false;
          this.processClose = false;
          this.SELECTED_PICTURE_FILE = null;
          this.START_UPLOAD = false;
          this.imageSrc = null;
          this.photoFile.nativeElement.value = "";
        })
      }
    }
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { firstName, lastName, phoneNumber, email } = f;
      const { STUDENT } = this.data;
      const { user } = this.auth;
      const item: ISchool = {
        key: STUDENT ? STUDENT.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: STUDENT ? STUDENT.created_at || new Date() : new Date(),
        created_by: STUDENT ? STUDENT.created_by || user.uid : user.uid,
        created_byRef: STUDENT ? STUDENT.created_byRef || this.ds.userProfileRef().doc(user.uid).ref : this.ds.userProfileRef().doc(user.uid).ref,
        updated_at: new Date(),
        updated_by: user.uid,
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${firstName} ${lastName} ${phoneNumber} ${email}`),
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        name: firstName,
        khmerName: lastName,
        email,
        phoneNumber,
        photoFileDetail: STUDENT ? STUDENT.photoFileDetail || null : null,
        displayName: firstName,
      }
      if (this.SELECTED_PICTURE_FILE) {
        this.START_UPLOAD = true;
        const file = this.SELECTED_PICTURE_FILE;
        const fileName = file.name;
        const uploadPath = `students/${item.key}/${this.ds.createId()}_${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        item.photoFileDetail = files;
        this.START_UPLOAD = false;
      }
      this.store.saveSchool(item, (success, res) => {
        if (success) {
          this.snackBar.open("Member has been saved successful.", "Done", { duration: 1000 });
          if (!isNew || STUDENT) {
            this.dialogRef.close('no')
            return;
          }
          this.form.reset();
          this.form.enable();
          this.processNew = false;
          this.processClose = false;
          this.isCreate = false;
          this.SELECTED_PICTURE_FILE = null;
          this.imageSrc = null;
          this.inputEl.nativeElement.focus();
        }

      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}
